import { TIERS } from "../services/constants";

// Single source of truth for tier display — used in the seller card, the
// storefront hero, the leaderboard row, and the seller dashboard.
export default function TierBadge({ tier, compact = false }) {
  const meta = TIERS.find((t) => t.key === String(tier)) || TIERS[0];
  if (meta.key === "unranked") {
    return <span className="tier-badge" title="No tier yet — verified profile">·</span>;
  }
  return (
    <span
      className={`tier-badge ${meta.cssClass}`}
      title={compact ? meta.label : `Tier ${meta.label}`}
    >
      {compact ? meta.label.replace("Crown", "") : meta.label}
    </span>
  );
}
